export default __webpack_public_path__ + "static/media/slider-2.b9f35fad.jpg";